import { memo } from 'react';
import { Box, Flex, MantineColor, Sx, Text } from '@mantine/core';

interface LabeledSectionProps {
  label: React.ReactNode;
  action?: React.ReactNode;
  color?: MantineColor;
  children: React.ReactNode;
  sx?: Sx;
}

const LabeledSectionBase = ({ label, color = 'gray', children, action, sx }: LabeledSectionProps) => {
  return (
    <Flex
      direction="column"
      pos="relative"
      mt={16}
      sx={(theme) => ({
        '.header-action': {
          marginTop: 4,
          opacity: 0,
          pointerEvents: 'none',
          transition: 'all 0.15s ease-in-out',
        },

        '&:hover': {
          '.header-action': {
            opacity: 1,
            pointerEvents: 'auto',
          },
        },

        ...(typeof sx === 'function' ? sx(theme) : sx),
      })}
    >
      <Flex
        className="labeled-section__header"
        pos="absolute"
        align="flex-start"
        justify="space-between"
        top={-18}
        left={0}
        sx={(theme) => ({
          borderRadius: 10,
          padding: '4px 16px 16px',
          height: 48,
          width: '100%',
          backgroundColor: theme.colors[color][0],
          border: `1px solid ${theme.colors[color][0]}`,
          zIndex: 1,
        })}
      >
        {typeof label === 'string' ? (
          <Text color="dark.4" fz="0.75rem" fw={600}>
            {label}
          </Text>
        ) : (
          label
        )}

        {action}
      </Flex>

      <Box
        sx={(theme) => ({
          marginTop: 10,
          padding: 16,
          borderRadius: 10,
          border: `1px solid ${theme.colors.gray[3]}`,
          zIndex: 2,
          backgroundColor: theme.white,
        })}
      >
        {children}
      </Box>
    </Flex>
  );
};

export const LabeledSection = memo(LabeledSectionBase);
